import { useEffect, useContext } from "react";
import AuthContext from "../contexts/auth";
import showPopup from "./PopUp";

const THROTTLE_MS = 3 * 60 * 60 * 1000;
const THRESHOLD_DAYS = 15;
const STORAGE_KEY = "premiumExpiryPopupLastShown";

export default function SubscriptionExpiryPopup() {
  const { user, isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated || !user?.subscriptionExpiresAt) return;

    const expiresAt = new Date(user.subscriptionExpiresAt);
    const daysLeft = Math.ceil(
      (expiresAt.getTime() - Date.now()) / (1000 * 60 * 60 * 24)
    );

    if (daysLeft < 0 || daysLeft > THRESHOLD_DAYS) return;

    const lastShown = Number(localStorage.getItem(STORAGE_KEY) || 0);
    if (Date.now() - lastShown < THROTTLE_MS) return;

    showPopup(
      `Faltam ${daysLeft} dia(s) para sua assinatura Premium acabar. Renove para não perder os benefícios!`,
      "alert"
    );
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }, [isAuthenticated, user]);

  return null;
}
